import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { CommonModalModel } from './common-modal.model';
import { ICommonModalData } from './common-modal.interface';
import { CommonModalTemplatesEnum } from './common-modal-templates.enum';
import { CommonModalDataService, temlatesHtml } from './common-modal-data.service';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Injectable()
export class CommonModalService {
  constructor(
    private commonModalDataService: CommonModalDataService,
    private commonInfo: CommonInfoService
  ) {
    this.commonModalDataService.modalsObs$.subscribe(
      (commonModalModel: CommonModalModel) => {
        if (!commonModalModel) {
          // warunek prawdziwy ponieważ currentModalTemplateName usuwany jest pozniej
          if (this.commonModalDataService.currentModalTemplateName !== CommonModalTemplatesEnum.MODAL_LOADER) {
            this.replaceBrowserUrl();

            this.commonModalDataService.tempModalIdInUrl = null;
          }

          return;
        }

        if (commonModalModel.modalData.templateName !== CommonModalTemplatesEnum.MODAL_LOADER) {
          window.history.pushState(null, null, this.commonModalDataService.modalId);

          this.commonModalDataService.tempModalIdInUrl = this.commonModalDataService.modalId;
        }
      }
    );

    fromEvent(window, 'popstate').subscribe((event: any) => {
      if (this.commonModalDataService.tempModalIdInUrl && this.commonModalDataService.currentModalTemplateName) {
        this.removeActiveModal();
      }
    });
  }

  public addToInitializedModalsList(commonModalModel: CommonModalModel, componentModule: any): void {
    this.commonModalDataService.initializedModalsList[commonModalModel.modalData.templateName] = {
      componentModule: componentModule,
      modalData: commonModalModel,
    };
  }

  public isTemplateDefined(
    templateName: CommonModalTemplatesEnum
  ): boolean {
    return !!this.commonModalDataService.initializedModalsList[templateName];
  }

  public setData(
    data: ICommonModalData,
    actionOnClose?: Function | Function[],
    actionOnUserClose?: Function | Function[],
  ): void {
    let modalDataModel: CommonModalModel;

    if (this.isTemplateDefined(data.templateName)) {
      modalDataModel = this.commonModalDataService.initializedModalsList[data.templateName].modalData;

      modalDataModel.setData(data, actionOnClose, actionOnUserClose);
    } else {
      modalDataModel = new CommonModalModel(data, actionOnClose, actionOnUserClose);
    }

    if (this.commonModalDataService.currentModalTemplateName && this.commonModalDataService.currentModalTemplateName !== data.templateName) {
      this.removeActiveModal();
    }

    this.commonModalDataService.currentModalTemplateName = modalDataModel.modalData.templateName;

    this.commonModalDataService.modals$.next(modalDataModel);
  }

  public getTemplate({templateName}: ICommonModalData): string {
    return temlatesHtml[templateName].html || '';
  }

  public getId({templateName}: ICommonModalData): string {
    return temlatesHtml[templateName].id || '';
  }

  public createModalData(templateName: CommonModalTemplatesEnum): ICommonModalData {
    const isVirginBrand = this.commonInfo.isVirginBrand;

    const data = {
      templateName: templateName,
      _modulesToInit: [
        'validation',
      ],
      isLoaderVisible: false,
      isVirginBrand
    };

    return data;
  }

  public isFormValid(event: Event): boolean {
    return !(<HTMLElement>event.target).closest('form').querySelectorAll('.form-input.error').length;
  }

  public removeModal(templateName: CommonModalTemplatesEnum): void {
    if (this.isTemplateDefined(templateName)) {
      this.commonModalDataService.initializedModalsList[templateName].modalData.removeModal();
    } else {
      console.error('Modal template is not defined');
    }
  }

  public removeActiveModal(): void {
    this.commonModalDataService.initializedModalsList[this.commonModalDataService.currentModalTemplateName].modalData.removeModal();
  }

  private replaceBrowserUrl(): void {
    const url = window.location.href.replace(this.commonModalDataService.tempModalIdInUrl, '');

    window.history.replaceState(null, null, url);
  }
}

